import React, { useState, useEffect } from "react";
import styles from "./sidebar-system-settings-link.module.scss";
import classNames from "classnames";
import SystemSettingIcon from "@assets/images/settings-icon.svg";
import { NavLink, useLocation } from "react-router-dom";
import { usePrevious } from "@hooks/usePrevious";
import { HomeRouterNames } from "@modules/home/config/home-router.names";
import Image from "material-ui-image";
import { Collapse, List, ListItem } from "@material-ui/core";

export const SidebarSystemSettingsLink: React.FC = () => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  const isSystemSettingsRoute =
    location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.SYSTEM_SETTING}`) ||
    location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.ORGANISATION_SETUP}`);

  const [open, setOpen] = useState<boolean>(isSystemSettingsRoute);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    if (location !== prevLocation) {
      const wasSystemSettings =
        prevLocation?.pathname?.toLowerCase().startsWith(`/${HomeRouterNames.SYSTEM_SETTING}`) ||
        prevLocation?.pathname?.toLowerCase().startsWith(`/${HomeRouterNames.ORGANISATION_SETUP}`);

      if (isSystemSettingsRoute && !wasSystemSettings) {
        setOpen(true);
      } else if (!isSystemSettingsRoute) {
        setOpen(false);
      }
    }
  }, [location, isSystemSettingsRoute, prevLocation]);

  return (
    <>
      <div
        onClick={handleClick}
        className={classNames(styles.Container, {
          [styles.Active]: open && isSystemSettingsRoute,
        })}
      >
        <div className={styles.ImageWrapper}>
          <Image
            src={SystemSettingIcon}
            alt="System Settings"
            disableSpinner
            animationDuration={700}
          />
        </div>

        <span>System Settings</span>
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.SYSTEM_SETTING}`}
            exact
            activeClassName={styles.ListItemActive}
          >
            - System Settings
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.ORGANISATION_SETUP}`}
            activeClassName={styles.ListItemActive}
          >
            - Organisation Setup
          </ListItem>
        </List>
      </Collapse>
    </>
  );
};
export default SidebarSystemSettingsLink;
